import { render, staticRenderFns } from "./tasksWrapper.vue?vue&type=template&id=51485214&"
import script from "./tasksWrapper.vue?vue&type=script&lang=js&"
export * from "./tasksWrapper.vue?vue&type=script&lang=js&"
import style0 from "./tasksWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports